<template>
  <div ref="home_wrap" class="home_wrap" :style="{ paddingTop: showDownload ? '2.25rem' : '1.3rem' }">
    <!-- 后台轮播图 -->

    <van-swipe ref="swipe" :autoplay="3000" class="swiper-container" :key="swipeKey">
      <van-swipe-item>
        <img src="../../assets/images/banner/1.png" style="border-radius: 10px">
      </van-swipe-item>
      <van-swipe-item>
        <img src="../../assets/images/banner/2.png" style="border-radius: 10px">
      </van-swipe-item>
      <van-swipe-item>
        <img src="../../assets/images/banner/3.png" style="border-radius: 10px">
      </van-swipe-item>
      <van-swipe-item>
        <div @click.stop="openLink(tglink.group_telegram)">
          <img src="../../assets/images/banner/5.png" style="border-radius: 10px">
        </div>
      </van-swipe-item>
    </van-swipe>
    <!-- 滚动通知 -->
    <div ref="notice" class="notice_root">
      <img class="notice_icon" src="../../assets/images/index/notice.gif">
      <div class="container">
        <van-notice-bar class="notice_content" background="none" :scrollable="notice_bar_scroll">
          <template #default>
            <div v-html="notice" />
          </template>
        </van-notice-bar>
      </div>
      <div @click="toSupport">
        <!-- <mail class="mailIcon" /> -->
        <img style="width: 20px;margin-left: 10px;" src="../../assets/images/index/mail.png" alt="">
      </div>
    </div>

    <!--      PC大屏幕加背景-->
    <div ref="navBox" class="sand_bot">
      <!-- Jackpot -->
      <div ref="jackpot" class="jackpot">
        <div class="jnumber">
          <countTo :start-val="startVal" :end-val="endVal" :duration="3000" :decimals="2" :decimal="','"
            :separator="'.'" />
        </div>
      </div>
      <NavTabs v-if="getTab" :tabs="tabs" @tabChange="handleNavClick" />
      <!-- 游戏列表 -->
      <indexListBR v-if="isCase5 && isGetData" :all_game_list="all_game_list" />
      <indexListHermes v-else-if="!isCase5 && isGetData" :all_game_list="all_game_list" />
    </div>

    <!--弹窗公告1-->
    <!-- <div
      v-show="show_tc"
      class="popup"
      @click="show_tc = false"
    >
      <div
        class="tc_content"
        @click.t.stop="a = 1"
      >
        <div
          class="notice_html"
          v-html="alter_notice"
        />
        <img
          src="../../assets/images/common/close.png"
          class="close_notice"
          @click="closeNotice()"
        >
      </div>
    </div> -->
    <!-- 兑换码页面 -->
    <div v-show="show_rc" class="popup" @click="show_rc = false">
      <div class="rc_content" @click.t.stop="a = 1">
        <div class="rc_container">
          <div class="rc_body-content">
            <div class="rc_body-content-top">
              <div class="rc_body-content-top-box1">
                <div />
                <div>{{ $t("新玩家奖金") }}</div>
                <div />
              </div>
              <div style="position: relative;">
                <van-field v-model="codeValue" class="codeInput" style="padding: 0;"
                  placeholder="Introduza o código de resgate">
                  <template #left-icon>
                    <i class="custom-icon">
                      <svg width="1.5em" height="1.5em" fill="currentColor" aria-hidden="true" focusable="false"
                        style="margin-top: .15rem;">
                        <symbol id="input_icon_dhm--svgSprite:all" viewBox="0 0 20.002 14.03">
                          <g id="input_icon_dhm--svgSprite:all_icon_dl_dhm" transform="translate(-0.992 -3.95)">
                            <path id="input_icon_dhm--svgSprite:all_Union_146" data-name="Union 146"
                              d="M-3910.779,1971.029h-13.41v-14h13.6a.38.38,0,0,1,.349.181.857.857,0,0,1,.141.4.892.892,0,0,1-.1.45.613.613,0,0,1-.361.31.85.85,0,0,0-.589.71.692.692,0,0,0,.11.469.925.925,0,0,0,.48.339.909.909,0,0,1,.4.331,1,1,0,0,1,.159.46.766.766,0,0,1-.11.45.677.677,0,0,1-.389.3.891.891,0,0,0-.521.32.832.832,0,0,0-.057,1,.94.94,0,0,0,.459.372.826.826,0,0,1,.419.339,1.012,1.012,0,0,1,.149.47.892.892,0,0,1-.1.48.823.823,0,0,1-.331.339,1,1,0,0,0-.724.782.8.8,0,0,0,.53.76.789.789,0,0,1,.4.35,1.019,1.019,0,0,1,.169.5.913.913,0,0,1-.1.478.66.66,0,0,1-.36.3.911.911,0,0,0-.52.309.762.762,0,0,0-.2.47.832.832,0,0,0,.14.509,1.176,1.176,0,0,0,.49.419.683.683,0,0,1,.32.35,1.022,1.022,0,0,1,.068.461.865.865,0,0,1-.159.41.378.378,0,0,1-.322.181Zm-2.592-4.36a1.69,1.69,0,0,0,.548-.3,1.38,1.38,0,0,0,.371-.509l0,.069a1.675,1.675,0,0,0,.141-.81,1.284,1.284,0,0,0-.207-.78,1.454,1.454,0,0,0-.491-.439,1.237,1.237,0,0,0,.44-.41,1.183,1.183,0,0,0,.179-.7,1.566,1.566,0,0,0-.12-.619,1.551,1.551,0,0,0-.339-.492,1.521,1.521,0,0,0-.529-.31,1.712,1.712,0,0,0-.652-.119,1.909,1.909,0,0,0-.639.109,1.54,1.54,0,0,0-.521.3,1.576,1.576,0,0,0-.348.479,1.658,1.658,0,0,0-.141.65h1a.671.671,0,0,1,.2-.481.65.65,0,0,1,.47-.169.714.714,0,0,1,.461.169.651.651,0,0,1,.2.51.766.766,0,0,1-.162.48.642.642,0,0,1-.52.2h-.15v.85h.15a.776.776,0,0,1,.559.2.811.811,0,0,1,.19.54.775.775,0,0,1-.2.561.724.724,0,0,1-.52.189.831.831,0,0,1-.28,0,.559.559,0,0,1-.229-.13.6.6,0,0,1-.161-.221.957.957,0,0,1-.07-.31h-1a1.928,1.928,0,0,0,.15.72,1.447,1.447,0,0,0,.378.491,1.357,1.357,0,0,0,.55.28,2.2,2.2,0,0,0,.64.09A2.273,2.273,0,0,0-3913.371,1966.669Zm-4.14-4.279a.737.737,0,0,1,.171.489.7.7,0,0,1-.07.329,1.1,1.1,0,0,1-.21.321l-2,2.331v.89h3.27v-.89l-2.071-.031,1.51-1.74.241-.3a2.291,2.291,0,0,0,.18-.281,1.159,1.159,0,0,0,.11-.3,1.192,1.192,0,0,0,0-.351,1.731,1.731,0,0,0-.12-.659,1.306,1.306,0,0,0-.339-.491,1.618,1.618,0,0,0-.51-.31,2.026,2.026,0,0,0-.66-.11,2,2,0,0,0-.65.109,1.435,1.435,0,0,0-.522.311,1.445,1.445,0,0,0-.35.491,1.759,1.759,0,0,0-.119.66h1a.721.721,0,0,1,.06-.318.475.475,0,0,1,.151-.211.453.453,0,0,1,.21-.119.978.978,0,0,1,.24,0h.042A.616.616,0,0,1-3917.512,1962.39Zm-4.2,4.359h1v-5.34h-1l-1.1.95v1.06l1.1-1Zm-8,4a1.56,1.56,0,0,1-.28-1.07v-4a.912.912,0,0,1,.089-.46.511.511,0,0,1,.37-.21.893.893,0,0,0,.279-.081,1.535,1.535,0,0,0,.361-.27,1.818,1.818,0,0,0,.3-.469,1.8,1.8,0,0,0,.129-.72,1.5,1.5,0,0,0-.319-1,1.215,1.215,0,0,0-.681-.419.728.728,0,0,1-.4-.181.566.566,0,0,1-.13-.43v-3a1.9,1.9,0,0,1,.231-1.07c.16-.22.49-.33,1.04-.37h3.271v14h-3.26a1.3,1.3,0,0,1-.209.017A1.3,1.3,0,0,1-3929.711,1970.75Z"
                              transform="translate(3930.993 -1953.05)" />
                          </g>
                        </symbol>
                        <use xlink:href="#input_icon_dhm--svgSprite:all" />
                      </svg></i>
                  </template>
                </van-field>
                <span class="paste" @click="paste">{{ $t('粘贴') }}</span>
              </div>
              <div class="rc_body-content-top-box3">
                <div>{{ $t("奖金金额") }}: <span>1,80- 8.888,00</span></div>
                <p>{{ $t('温馨提示：需缴纳押金') }} <span>0 </span>{{ $t("提取所获得的利润！") }}</p>
              </div>
            </div>
            <div class="rc_introduction">
              <span class="rc_introduction-title">{{ $t("活动说明") }}:</span>
              <div>
                {{ $t("tip4") }}
                <br>
                {{ $t("tip5") }}
                <br>
                {{ $t("tip6") }}
                <br>
                {{ $t("tip7") }}
                <br>
                {{ $t("tip8") }}
                <br>
                {{ $t("tip9") }}
                <br>
              </div>
            </div>
            <div class="bottomBlack" />
            <div class="rc_btn">
              <van-button class="submitCode" :disabled="isDisabled" type="primary" @click="submitCode">
                {{ $t("救援奖金") }}
              </van-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--弹窗公告2-->
    <div v-show="show_tc2 && rechargeConfigList.length" class="popup2" @click="closeRechargeTip()">
      <div class="tc_content2">
        <img src="../../assets/images/logo/logo.png" class="tc_logo" />
        <div class="tc_head">{{ $t('额外初始存款奖金') }}</div>
        <table id="tc-table">
          <tr style="color: #111" class="tc_bgw">
            <th>{{ $t('首次充值') }}</th>
            <th>{{ $t('奖励价值') }}</th>
          </tr>
          <tr v-for="(item, index) in rechargeConfigList" :key="index" v-if="item.gift_amount != 0">
            <td>≥{{ item.money }}</td>
            <td>{{ item.gift_amount }}</td>
          </tr>
        </table>
        <div style="width: 90%; margin: 0.4rem auto">
          <div>
            <van-icon name="passed" color="rgb(105, 255, 2)" size="0.4rem" style="margin-right: 5px" />
            <span style="color: #fff">{{ $t('今天我不再出现') }}</span>
          </div>

          <div>
            <van-icon name="passed" color="rgb(105, 255, 2)" size="0.4rem" style="margin-right: 5px" />
            <span style="color: #fff">{{ $t('永久隐藏') }}</span>
          </div>
          <div class="tcbtn" @click="">{{ $t("继续") }}</div>
          <div class="clear"></div>
        </div>
        <img src="../../assets/images/common/close.png" class="close_recharge_tc" @click="closeRechargeTip()" />
      </div>
    </div>
    <div class="popup2" v-show="show_tc3">
      <div class="sign-box">
        <img src="https://cdn.bz999xyz.xyz/image/2025/07/03/2749396f2d7740a0a4bff6509bfa084e.png" @click="toArticle()"
          alt="">
        <div class="checkBox">
          <van-checkbox v-model="signChecked" shape="square" class="check" :icon-size="14">
            {{ $t('今天我不再出现') }}
          </van-checkbox>
        </div>
        <div @click="closeSign"> <img src="../../assets/images/common/close.png" class="close_sign_tc" /></div>
      </div>
    </div>
    <!-- 游戏盒子-->
    <div v-show="show_game_box" id="bigBox" class="game-box">
      <div class="back_to_desk" @click="beforeCloseGame()">
        <van-icon name="wap-home-o" class="close_game_btn" />
        <div style="font-size: 0.3rem">
          {{ $t("退出") }}
        </div>
      </div>
    </div>
    <div id="indexbr_box">
      <!-- <a
        v-if="showTop6"
        class="telegram"
        @click="$router.push('activity/red')"
      >
        <img
          src="../../assets/images/index/red.gif"
          width="100"
        >
        <div
          class="icon_box"
          @click.prevent="closeImg('showTop6')"
        >
          <van-icon
            name="close"
            class="close_icon"
          />
        </div>
      </a> -->
      <a v-if="showTop5" class="telegram" @click.prevent="$router.push('turnTable')">
        <img src="../../assets/images/Turntable/t.gif" width="100">
        <div class="icon_box" @click.stop="closeImg('showTop5')">
          <van-icon name="close" class="close_icon" />
        </div>
      </a>
      <!-- <a
        v-if="showTop4"
        class="telegram"
      >
        <img
          src="../../assets/images/index/whatsapp.png"
          class="invitation"
          width="100"
          style="border-radius: 20px"
          @click.stop="openLink(tglink.group_whatsapp)"
        >
        <div
          class="icon_box"
          @click="closeImg('showTop4')"
        >
          <van-icon
            name="close"
            class="close_icon"
          />
        </div>
      </a> -->
      <!-- <a
        v-if="showTop1"
        class="telegram"
      >
        <img
          src="../../assets/images/index/top1.gif"
          class="invitation"
          width="100"
          style="border-radius: 20px"
          @click.stop="$router.push('/activity?tab=1')"
        >
        <div
          class="icon_box"
          @click="closeImg('showTop1')"
        >
          <van-icon
            name="close"
            class="close_icon"
          />
        </div>
      </a>
      <a
        v-if="this.rate"
        :href="getUrl()"
        class="telegram"
      >
        <img
          src="../../assets/images/index/RedEnvelope.png"
          width="100"
        >
      </a>
      <a
        v-if="showTop2"
        class="telegram"
        @click="openLink(tglink.group_ins)"
      >
        <img
          src="../../assets/images/index/instagram_2111463.png"
          width="100"
        >
        <div
          class="icon_box"
          @click.stop="closeImg('showTop2')"
        >
          <van-icon
            name="close"
            class="close_icon"
          />
        </div>
      </a>
      <a
        v-if="showTop3"
        class="telegram"
        @click.stop="openLink(tglink.group_telegram)"
      >
        <img
          src="../../assets/images/index/top3.gif"
          width="100"
        >
        <div
          class="icon_box"
          @click.stop="closeImg('showTop3')"
        >
          <van-icon
            name="close"
            class="close_icon"
          />
        </div>
      </a> -->
      <fixedRightSwipe :right-list="newRightList === null ? rightList : newRightList" @closeImg="closeListImg" />
      <div v-show="showToTop" class="hoverButton" :style="{ pointerEvents: showToTop ? 'auto' : 'none' }"
        @click.stop="toTop">
        <i class="toTopI"><svg width="2em" height="2em" fill="#fff" class="" viewBox="0 0 12.389 19.945">
            <path id="0d7322b3273dc8daf00c7dc9c60b11f5-comm_icon_fhdb"
              d="M37.695,23h12c.13,0,.195.13.195.26s-.065.547-.195.547h-12c-.13,0-.195-.417-.195-.547S37.565,23,37.695,23Zm6,2.924A8.169,8.169,0,0,1,47.982,33.2a2.923,2.923,0,0,1,1.429,3.118,3.05,3.05,0,0,1-2.339,2.664c-.65-.065-.455-.52-.455-.52l-.195-.845s-.91,1.364-1.169,1.364H42.005c-.26,0-1.169-1.364-1.169-1.364l-.195.845s.13.455-.455.52a3.05,3.05,0,0,1-2.339-2.664A3.188,3.188,0,0,1,39.406,33.2,8.408,8.408,0,0,1,43.694,25.924ZM41.94,31.316a1.755,1.755,0,1,0,3.508,0,1.755,1.755,0,1,0-3.508,0Zm.455,10.72a.375.375,0,0,0,.39-.39V39.827a.39.39,0,1,0-.78,0v1.819A.374.374,0,0,0,42.4,42.036Zm1.364.91a.419.419,0,0,0,.39-.39V39.892a.39.39,0,0,0-.78,0v2.664A.419.419,0,0,0,43.759,42.945Zm1.234-1.364a.374.374,0,0,0,.39-.39v-1.3a.39.39,0,0,0-.78,0v1.3A.374.374,0,0,0,44.994,41.581Z"
              transform="translate(-37.5 -23)" fill-rule="evenodd" />

          </svg></i>
        <span>{{ $t("顶部") }}</span>
      </div>
    </div>
    <ft />
    <avtList3 :avt-img="avtImg" @close="closeAvt" @showPopup="handleCustomEvent" />

    <ModalComponent v-for="(modal, index) in modals" v-show="modal.visible == 3" :key="index">
      <p class="title">
        {{ modal.title }}
      </p>
      <p v-html="modal.content" />
      <div class="close_box" @click="handleModalClosed(index)">
        <img src="../../assets/images/common/close.png" class="close">
      </div>
    </ModalComponent>
    <div v-if="showOpenPage" class="openPage">
      <div class="skip-button" @click="showOpenPage = false">
        {{ $t("跳过") }}
      </div>
      <img src="../../assets/images/video.gif" alt="">
      <!-- <video
        class="video"
        autoplay
        muted
      >
        <source
          src="../../assets/images/video.mp4"
          type="video/mp4"
        >
        您的浏览器不支持 video 标签。
      </video> -->
    </div>
    <LogoLoading v-if="showLogoLoading" />
  </div>
</template>

<script>
import Vue from "vue";
import mail from "../../components/svg/mail.vue";
import Fetch from "../../utils/fetch";
import { NoticeBar } from "vant";
import ft from "../../components/ft.vue";
import Axios from "axios";
import {
  Swipe,
  SwipeItem,
  Icon,
  Progress,
  Popover,
  Field,
  Tabs,
  Tab,
  Lazyload,
  Button,
} from "vant";
import countTo from "vue-count-to";
import avtList3 from '../../components/avtList3.vue'
import fixedRightSwipe from '../../components/fixedRightSwipe.vue'
import r1 from '../../assets/images/index/top3.gif'
import r2 from '../../assets/images/index/instagram_2111463.png'
import r3 from '../../assets/images/index/top1.gif'
import NavTabs from "../../components/navTabs.vue"
import ModalComponent from "../../components/ModalComponent.vue"
import { EventBus } from '../../utils/utils.js'
import indexListHermes from '../../components/indexListHermes.vue'
import fetch from "../../utils/fetch";
import { Number } from "core-js";
import indexListBR from "../../components/indexHermesBR.vue"
import LogoLoading from '@/components/logoLoading.vue'

const collectStorageKey = "COLLET_LIST"
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon)
  .use(Progress)
  .use(Popover)
  .use(Field)
  .use(NoticeBar)
  .use(Tabs)
  .use(Tab).use(Button)
  .use(Lazyload, {
    lazyComponent: true,
  });

export default {
  name: "Index",
  components: {
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem,
    ft,
    countTo,
    mail,
    avtList3,
    fixedRightSwipe,
    ModalComponent,
    indexListHermes,
    NavTabs,
    indexListBR,
    LogoLoading
  },
  props: {
    showDownload: Boolean
  },
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      tabs: [],
      getTab: false,
      notice_bar_scroll: false,
      myBaners: [],
      isGetData: false,
      isCase5: false,
      isDisabled: true,
      nav_active: 0,
      show_rc: false,
      show_kefu: true,
      msg_show: false,
      loading: false,
      signChecked: false,
      codeValue: "",
      swipeKey: 0,
      show_tc1: false,
      icon: [],
      data: {
        item1: { show: true },
        item2: { show: true },
        item3: { show: true },
      },
      islogin: false,
      isapp: false,
      show_tc3: false,
      tglink: "",
      insLink: "",
      show_tc: false,
      show_tc2: true,
      tc_content: "",
      gameList: [],
      show_game_box: false,
      game_url: "",
      gameType: 0,
      username: null,
      all_game_list: [],
      all_game_list_bak: [],
      keyword: "",
      notice: "",
      alter_notice: "",
      head_image: "",
      level: 0,
      total_bet_amount: 0,
      sub_level_amount: 0,
      group_service: "",
      service: "",
      leftCount: 0,
      secondsUntilNextHour: 0,
      timeStr: "00:00:00",
      time_id: null,
      is_ban: 0,
      evtSource: null,
      category: "slots",
      banners: [],
      showcbl: false,
      avd_img: null,
      avd_url: null,
      startVal: 0,
      endVal: 0,
      step_show: 12,
      max_show_array: [18, 18, 18, 18],
      jtid: null,
      todayInfo: {},
      rechargeConfigList: [],
      userInfo: {},
      send2index: undefined,
      scroll: 0,
      showTop1: true,
      showTop2: true,
      showTop3: true,
      showTop4: true,
      showTop5: true,
      showTop6: true,
      rate: null,
      showToTop: false,
      showOpenPage: false,
      modals: [
      ],
      avtImg: [],
      newRightList: null,
      colletList: [],
      showLogoLoading: false,
    };
  },
  computed: {
    colletIds() {
      return this.colletList.map(({ id }) => id)
    },
    rightList() {
      return [
        {
          img: r1,
          func: () => {
            this.openLink(this.tglink.group_telegram)
          }
        },
        {
          img: r2,
          func: () => {
            this.openLink(this.tglink.group_ins)
          }
        },
        {
          img: r3,
          func: () => {
            this.$router.push('/activity?tab=1')
          }
        },

      ]
    }
  },
  watch: {
    keyword: function (newn) { },
    codeValue: function (newVal) {
      if (newVal !== '') {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    send2index(newval, oldval) {
      console.log(newval, oldval, 'send2')
    },
    rightList(newVal) {
      console.log(newVal)
      this.newRightList = newVal
    }
  },
  created() {
    this.$bus.$emit("send2ftnav", 0);
    this.$bus.$on("isShowRedemptionCode", (value) => {
      this.show_rc = value;
    });
    //监听左侧菜单传来的事件
    this.$bus.$on("send2index", (idx) => {
      this.tabChange(idx);
      this.send2index = idx;
      window.removeEventListener("scroll", this.scrollToTop);
    });

    //获取通知
    // this.getNotice();
    this.isShowTop("showTop1");
    this.isShowTop("showTop2");
    this.isShowTop("showTop3");
    this.isShowTop("showTop4");
    this.isShowTop("showTop5");
  },

  mounted() {
    console.log(this.showDownload, 'showDownloadshowDownload')
    this.$bus.$emit("send2headshow", false);
    this.getJackpot();
    this.initTab();
    this.getAlterNotice();
    this.getUserInfo();
    this.getGameList();
    this.getCollet();
    //设置jackpot定时器
    clearInterval(this.jtid);
    this.jtid = setInterval(() => {
      this.startVal = this.endVal;
      this.endVal = this.endVal + Math.random() * 100;
    }, 10000);
    window.addEventListener("scroll", this.scrollToTop, true);
    window.addEventListener('resize', this.handleResize);
    EventBus.$on('getUserInfo', this.getUserInfo);
    EventBus.$on('leftNavChange', this.handleNavClick);
    EventBus.$on('leftNavChange', data => {
      this.handleNavClick(data);
    })
  },
  destroyed() {
    this.$bus.$emit("send2headshow", true);
    clearInterval(this.time_id);
    clearInterval(this.jtid);
    window.removeEventListener("scroll", this.scrollToTop);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      setTimeout(() => {
        if (this.$refs.swipe) {
          this.$refs.swipe.resize();
        }
      }, 1000)
    },
    handleNavClick(item) {
      let name = 'PG';
      var target = "";
      if (item.id == 2) {
        target = document.getElementById(name)
      } else {
        target = document.getElementById(item.name)
      }
      // const target = document.getElementById(name)
      if (!target) return
      // 获取动态头部高度
      const header = document.getElementById('header_hea');
      const headerHeight = header ? header.offsetHeight : 0;
      // 计算最终位置
      const targetTop = target.getBoundingClientRect().top + window.scrollY
      const scrollPosition = targetTop - headerHeight;
      // 兼容性更好的平滑滚动
      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth'
      })
      this.showToTop = true;
    },
    handleCustomEvent() {
      if (this.modals.length > 0) {
        this.startModals();
      }
      this.show_tc1 = true
    },
    handleModalClosed(index) {
      this.modals[index].visible = 1;
      if (this.modals.length > 1) {
        this.modals[index + 1].visible = 3;
      }
    },
    getUrl() {
      this.$router.push('/commission')
    },
    closeImg(type) {
      this[type] = false;
      localStorage.setItem(type, new Date().getTime());
    },
    openLink(url) {
      console.log(url);
      window.open(url);
    },
    getUrl() {
      return this.$router.resolve({ name: 'commission' }).href;
    },
    async paste() {
      try {
        const text = await navigator.clipboard.readText();
        // console.log('粘贴成功: ', text);
        this.codeValue = text;
      } catch (err) {
      }
    },
    submitCode() {
      Fetch("/box/exchange_code", {
        code: this.codeValue
      }).then((r) => {
        console.log(r);
        if (r.code !== 0) {
          this.$message({
            // title: this.$store.state.config.site_name,
            type: "success",
            message: r.msg,
            center: true,
            showClose: true,
            offset: 300,
          });
          this.show_rc = false;
        } else {
          this.$message({
            // title: this.$store.state.config.site_name,
            type: "error",
            message: r.msg,
            center: true,
            showClose: true,
            offset: 300,
          });
        }
      });
    },
    initTab() {
      Fetch("/platform/nav", {
        is_nav: 1
      }, { method: 'get' }).then((res) => {
        if (res.data) {
          this.tabs = res.data;
          this.getTab = true;
          EventBus.$emit('nav-data-ready', res.data);
        }
      })
    },
    isShowTop(type) {
      const time = localStorage.getItem(type);
      if (time) {
        const newTime = new Date().getTime();
        if (newTime - time > 3600000) {
          this[type] = true;
        } else {
          this[type] = false;
        }
      }
    },
    closeSign() {
      this.show_tc3 = false;
      const data = {
        value: this.signChecked,
        date: new Date().getTime()
      }
      localStorage.setItem("signPop", JSON.stringify(data))
    },
    scrollToTop() {
      var scrollTop =
        document.body.scrollTop ||
        window.scrollY ||
        document.documentElement.scrollTop;
      if (scrollTop >= 200) {
        this.showToTop = true
      } else {
        this.showToTop = false
      }
    },
    onLoad() {
    },
    closeRechargeTip() {
      if (this.username) {
        //看一下今天有没有弹过了
        let today = new Date();
        if (localStorage.getItem("date_time") != today.getHours()) {
          localStorage.setItem("date_time", today.getHours());
        }
      }
      this.show_tc2 = false;
    },
    beforeCloseGame() {
      document
        .getElementById("bigBox")
        .removeChild(document.getElementById("myiframe"));
      this.show_game_box = false;
      this.game_url = "";
      //重新获取用户的余额
      this.getUserInfo();
      EventBus.$emit('refresh_bet')
    },
    getJackpot() {
      Fetch("/platform/init", {}, { method: "get" }).then((r) => {
        if (r.data) {
          if (r.data.window.length) {
            this.avtImg = r.data.window;
          }
          localStorage.setItem("showSign",r.data.signin_status);
          r.data.money = parseFloat(r.data.jackpot);
          this.startVal = Number(r.data.jackpot) - 500;
          this.endVal = Number(r.data.jackpot);
          this.notice = r.data.notice;
          this.notice_bar_scroll = true;
          let lang = 'pt';
          if (!localStorage.getItem('X-language')) {
            localStorage.setItem("X-language", lang)
          }
          EventBus.$emit('lang-data-ready', r.data);
        }
      });
      Fetch("/platform/support").then((r) => {
        this.tglink = r.data;
        let u = navigator.userAgent;
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
        this.$store.commit('setAppDownloadLink', isIOS ? '' : r.data.app_download_link)
      });
    },
    tabChange(v) {
      this.nav_active = v;
      if (v == 0) {
        this.category = "Popular";
      }
      if (v == 1) {
        this.category = "Slots";
        this.$router.push("/recente?gameId=SLOTS&flag=true")
      }
      if (v == 2) {
        this.category = "Pg";
        this.$router.push("/recente")
      }
      if (v == 3) {
        this.category = "Recente";
        this.$router.push("/recente?title=Favoritos")
      }
    },
    toSupport() {
      this.$parent.isShowSupport = true;
      EventBus.$emit('supTabChange', 2);
    },
    scrollToCard(refName) {
      let cardElement = this.$refs[refName][0];
      this.scroll = cardElement.offsetTop;
      if (cardElement) {
        // 使用原生的 scrollIntoView 方法来滚动到元素位置
        cardElement.scrollIntoView();
      }
    },
    toArticle() {
      this.$router.push({
        path: "/article",
        query: { "signShow": "true", index: 6 },
      });
    },
    getAirdrop() {
      Fetch("/airdrop/getAirdrop", {}).then((res) => {
        //console.log(r);
        this.$toast({
          background: "#07c160",
          message: res.msg,
          duration: 5000,
        });
        if (res.code == 1) {
          setTimeout(() => {
            this.getUserInfo();
          }, 2500);
        }
      });
    },
    getUserInfo() {
      Fetch("/user/userinfo").then((r) => {
        if (r.data) {
          this.userInfo = r.data.userinfo;
          this.username = r.data.userinfo.username;
          this.userbalance = r.data.userinfo.money;
          this.head_image = r.data.userinfo.avatar;
          this.level = r.data.userinfo.level;
          this.total_bet_amount = r.data.userinfo.total_bet_amount;
          this.sub_level_amount = r.data.userinfo.sub_level_amount;
          this.is_ban = r.data.userinfo.is_rob;
          this.$parent.changeBalance(r.data.userinfo.money);
          if (r.data.rate !== 0) {
            localStorage.setItem("rate", r.data.userinfo.rate)
            this.rate = r.data.userinfo.rate;
          } else {
            localStorage.removeItem("rate");
            this.rate = null;
          }
        } else {
          localStorage.removeItem("user_balance");
          localStorage.removeItem("rate");
        }
      });
    },
    getGameList(v) {
      if (!window.isShowOpen) {
        this.showOpenPage = true
        window.isShowOpen = true
      }
      let url = "/game/list";
      this.category = "";
      Fetch(url, {
        type: this.category,
      }).then((res) => {
        if (typeof this.send2index === 'number') {
          this.tabChange(this.send2index)
          this.send2index = undefined
        }
        for (let item in res.data.list) {
          let step_show = 8;
          if (res.data.list[item].direction == 1) {
            step_show = 99;
          }
          this.all_game_list[item] = {
            ...res.data.list[item],
            step_show: step_show,
            case_tpl_id: res.data.case_tpl_id
          }
        }
        this.all_game_list_bak = res.data.list;
        if (this.all_game_list[0].case_tpl_id == 'case_5') {
          this.isCase5 = true
        }
        this.isGetData = true;
        console.log(this.all_game_list)
        setTimeout(() => {
          this.showOpenPage = false
        }, 2000);
      });
    },
    getPGHtml(game_id) {
      // console.log(this.userInfo);return null;
      // if (this.userInfo.remark) {
      //   if (
      //     this.userInfo.remark.indexOf("模拟") != -1 ||
      //     this.userInfo.remark.indexOf("测试") != -1
      //   ) {
      //     let _this = this;
      //     return new Promise((resolve, reject) => {
      //       Axios.post("/api/demo/getPGHtml2", {
      //         game_id: game_id,
      //         user: _this.userInfo,
      //       })
      //         .then(function (response) {
      //           resolve(response.data);
      //         })
      //         .catch(function (error) {
      //           reject(error);
      //         });
      //     });
      //   }
      // }

      return new Promise((resolve) => {
        Fetch(
          "/demo/getPGHtml2",
          { game_id: game_id, token: localStorage.getItem("token") },
          {},
          true
        ).then((res) => {
          resolve(res);
        });
      });
    },
    getGameUrl(gameId) {
      return new Promise((resolve, reject) => {
        Fetch("/game/startup", { game_id: gameId }, { method: 'get' }, false, false).then(
          (res) => {
            resolve(res);
          }
        ).catch(err => {
          reject(err);
        });
      });
    },
    getRecent(id) {
      Fetch("/game/collect", {
        game_id: id,
        type: 0
      }).then(res => {
        this.getGameList()
      })
    },
    closeNotice() {
      localStorage.setItem("notify", this.alter_notice);
      this.show_tc = false;
    },
    getAlterNotice() {
      Fetch("/recharge/init", {}).then((res) => {
        if (res.data) {
          this.rechargeConfigList = res.data.config;
          let today = new Date();
          if (localStorage.getItem("date_time") != today.getHours()) {
            localStorage.setItem("date_time", today.getHours());
            this.show_tc2 = true;
          } else {
            this.show_tc2 = false;
          }
        }
      });
    },
    async playGame(item, pItem) {
      if (pItem.is_game_list == 0) {
        return this.$router.push({
          path: "recente",
          query: { cate_id: item.id, flag: true, pid: item.pid },
        });
      }
      if (this.userInfo.remark) {
        if (
          this.userInfo.remark.indexOf("模拟") != -1 ||
          this.userInfo.remark.indexOf("测试") != -1
        ) {
          if (pItem.name != "PG") {
            return this.$message({
              message: this.$t("模拟账号只能玩PG游戏"),
              type: "error",
            });
          }
        }
      }
      if (!this.username) {
        this.$parent.login();
        return;
      } else {
        //被后台禁止游戏了
        if (this.is_ban) {
          this.$toast({
            background: "#07c160",
            message: this.$t("您当前账号尚未开通游戏功能，请联系您的经理"),
            duration: 5000,
          });
          return;
        }
        if (!item.is_works) {
          this.$toast({
            background: "#07c160",
            message: this.$t("该游戏正在维护中"),
            duration: 5000,
          });
          return;
        }
      }
      if (this.userbalance < 0.4) {
        return this.$parent.isShowRecharge = true;
      }

      this.showLogoLoading = true
      if (item.is_recent === 0) {
        this.$set(item, 'is_recent', 1)
        await this.getRecent(item.id);
      }

      //玩游戏前 需要先判断一下是PG的游戏还是JDB的游戏
      //先获取一下游戏的链接
      let resp = await this.getGameUrl(item.id);
      if (resp.code == 0) {
        this.showLogoLoading = false
        this.$toast({
          background: "#07c160",
          message: resp.msg,
          duration: 3000,
        });
        return;
      }
      return this.launchJDB(resp.data.game_url);
    },
    launchJDB(url) {
      this.showLogoLoading = false
      this.show_game_box = true;
      var iframe = document.createElement("iframe");
      iframe.setAttribute("height", "100%");
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("id", "myiframe");
      iframe.setAttribute("allowfullscreen", "true");
      iframe.setAttribute("webkitallowfullscreen", "true");
      iframe.setAttribute("mozallowfullscreen", "true");
      iframe.setAttribute("src", url);
      iframe.addEventListener("load", function () {
        console.log("iframe loaded!");
      });
      var bigBox = document.getElementById("bigBox");
      bigBox.appendChild(iframe);
    },

    createIframe(content) {
      this.show_game_box = true;
      var iframe = document.createElement("iframe");
      iframe.setAttribute("height", "100%");
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("id", "myiframe");
      iframe.addEventListener("load", function () {
        console.log("iframe loaded!");
      });
      var bigBox = document.getElementById("bigBox");
      bigBox.appendChild(iframe);
      iframe.contentWindow.document.write(
        "<script>alert(1); window.location.href = " + content + ""
      );
    },
    closeAvt() {
      setTimeout(() => {
        this.show_tc = true
      }, 200);
    },
    toTop() {
      document.body.scrollTo({ top: 0, behavior: 'smooth' });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    jumpRecent(item) {
      this.$router.push(`/recente?cate_id=${item.id}&flag=true&pid=${item.pid}`)
    },
    closeListImg(i) {
      this.rightList.splice(i, 1)
      this.newRightList = [...this.rightList]
    },

    initPopup() {
      Fetch("/index/init", {
        url: window.location.href
      }).then(res => {

      })
    },

    startModals() {
      this.openModal(0);
    },
    openModal(index) {
      this.modals[index].visible = 3
    },
    getCollet() {
      this.colletList = localStorage.getItem(collectStorageKey) ? JSON.parse(localStorage.getItem(collectStorageKey)) : []
    },
    setFavoritos(item) {
      const index = this.colletList.findIndex(collet => collet.id === item.id)
      if (index > -1) {
        this.colletList.splice(index, 1)
      } else {
        this.colletList.push(item)
      }
      localStorage.setItem(collectStorageKey, JSON.stringify(this.colletList))
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";
@headerHeight: 2.4rem;
@mainColor: #005dfe;
@mainBgColor: #95846f;

.svgStyle {
  color: @textcolor1;
}

.popup {
  position: fixed;
  top: 0rem;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup2 .sign-box {
  color: #fff;
  position: relative;

  img {
    width: 9rem;
  }
}

.popup2 .sign-box .close_sign_tc {
  width: 0.7rem;
  height: 0.7rem;
}

.myFixed {
  position: fixed;
  top: 1.3rem;
  z-index: 2;
  width: 100%;
  max-width: @maxWidth;
}

.rc_content {
  width: 95%;
  max-width: @maxWidth*0.95;
  // max-width: 12rem;
  //height: 6rem;
  // overflow-x: hidden;
  // overflow-y: auto;
  position: absolute;
  background: @activityColor;
  padding: 0 0.3rem;
  box-sizing: border-box;
  border-radius: 0.35rem;
  top: -1.3rem;
  // background-image: url("../../assets/images/common/bg1.png");
  position: relative;
  padding-top: 0.2rem;

  .rc_container {
    .rc_body-content {
      display: flex;
      flex-direction: column;
      height: 16rem;
      // justify-content: space-between;
      width: 100%;
      overflow-y: auto;

      .rc_body-content-top {
        display: flex;
        flex-direction: column;
        gap: .2rem;
        margin-top: 0;
        overflow: initial;
        padding: .2rem;
        background-color: @secondary-color;
        border-radius: .14rem .14rem .1rem .1rem;
        font-size: .22rem;

        .rc_body-content-top-box1 {
          align-items: center;
          display: flex;
          height: 1rem;
          justify-content: center;
          margin: 0 .4rem;
          position: relative;
        }

        .rc_body-content-top-box3 {
          color: @textcolor1;
          // display: flex;
          font-size: .3rem;

          div {
            span {
              color: @textcolor4 !important;
            }
          }

          p {
            span {
              color: #fff !important;
            }
          }
        }
      }

      .rc_introduction {
        // display: flex;
        margin-top: .3rem;
        overflow: initial;
        padding: .2rem;
        background-color: @secondary-color;
        border-radius: .14rem .14rem .1rem .1rem;
        font-size: .32rem;

        .rc_introduction-title {
          font-weight: 700;
        }

        div {
          font-size: .32rem;
          color: @textcolorf;
          line-height: .5rem;
        }
      }

      .rc_btn {
        bottom: 0;
        left: 0;
        padding-top: .2rem;
        position: absolute;
        width: 100%;
        text-align: center;
        margin: .5rem auto 0;
        margin-bottom: .3rem;
        // background-color: @activityColor;
      }

      .bottomBlack {
        padding-top: 2rem;
      }
    }
  }

}

/* 针对Webkit浏览器，如Chrome、Safari */
::-webkit-scrollbar {
  width: 0;
  height: 0;
  // background: transparent;
  /* 如果需要的话 */
}

.toTopI {
  background-color: @third-color;
  border-radius: 50%;
  padding: .1rem;
  box-sizing: border-box;
  margin-bottom: .1rem;
}

/deep/ .van-notice-bar__content b {
  color: @anttextcolor !important;
  font-size: .3rem;
}

/* 针对Firefox */
* {
  scrollbar-width: none;
  /* Firefox */
}

/* 针对IE和Edge */
body {
  -ms-overflow-style: none;
  /* IE and Edge */
}

.custom-icon path {
  fill: @textcolor1;
}

.rc_body-content-top-box1>div:first-child {
  width: 1.12rem;
  height: 1rem;
  background-position: 0 0;
  background-image: url(data:image/webp;base64,UklGRmADAABXRUJQVlA4TFMDAAAvecAdEG+gppEU6O5a/JsjVHRoeG0ICIr8H01R2zZQyh/U7ucgTTPTto1RlEnfQRl/jcQC8P+n5VwYxdJzSx6GDLGumiUGcmzbdtsGU7ggHFrl0FGQA8vkQFecghO0uJRzmIDMMil8lVZmhSFoCBoT8ID/3/0ObUT/HUmSJCQ1OgSDemqo8QtBEHTWkkKtrByKOjo6+iWq1zOWuroal1fGz6SkDg7k6/RUcnlp4/HRzloJK4e21rO2K5fmeCw0Y28aDosH5jgpPRzyx0G65j7WN/Gyjg8V47ELwSoxX048ecuXPPWWL1nEfLnhLV+2Lx56GT95zVew6jVfaeIzX+mav+fI03ri8TnSkW9f+XpOEp/PkTWJr3wVzn3lq3Ak5ssJZr4cTjz6Yo04fhtOjqztOaHl6zOAurV11mn5ijIwst5T6TopX12gGuLaly8WUL1YQN+XL15ix9Twle6LdtzMqWCUUWf7oh0C1XNjQpgcti8iAGiYLqrGZGOyL7oQNWqjnvOb7IsaJs6XgXotJ8KQ7IvX+GrMLDCNfv4DN2RfvMTQmG6ISQzMMSbYvogwMuKQUUOV7Ysob6YriLAt20mL5YvXGIho5oQYPorDIm5IvqihKu8oDGvZFdkiXJN80YU4bWdUUDeinYS4YfmigolzcSEG9i5Em8MEzRe14i0laqI5Hn8Jsc3zRQWYaP6IUKilOARueL5oh7BXnemLt0Um4zgUX7qh+OJ9LGtK/kacVygu3jF88RoltRS3LiooqRu1LyyIeJej9oUWtS+0qH2hRe0LLWpfaFH7gkpKH6t9oYXhi/dxSY0yluOSuvO75z9yfNEqVt4+tgq1x/KF67hO8IUWtS/UaH2hRusLNVpfaFH7QovaF1rUvqDCzhdhz2d9xMuYsOfTwukjX4Q9n3pDsseEPV8HYc/XQdjzqaTkMWHP50LPl9oX3I+Qx/8FX2j/t5fXVcl/G9Keb+x2LsDa820UG23Pd22kPd+1qX2hGI9z1L7QjhW+0I/tH/GZr+fER77UvtCOFb7gjK2+YOfL6gt2vtS+0I4VvvAwDoKUmC8nAmK+3KDny+uez/JFj9RWveYrZT9HFL7gj8nPETeI+XLDY77W/D5HfnJ9Yaez5s0XYwA=);
  background-size: 100% 100%;
}

.rc_body-content-top-box1>div:nth-child(2) {
  height: 1rem;
  background-position: 0 0;
  background-image: url(data:image/webp;base64,UklGRsYFAABXRUJQVlA4TLkFAAAv98AdABfwBarxF5AkR/y/smD+YwnjCASS9tceIiJCd5wATiBVuQveP4GznxW0AMGUqclk7CCi/5DcthEkdc1otrOTPaUd7RccJqASWAUOYFD7eJADCN3+u+jrvv4JIvoPyQHbsE3WERET+USRyhcsP/152/d9DzqmNlVNN7Xff+j6j36O9i5FtUu41tDpv6H7bZkrPeNAnvIiLPPf2bZpMD1e5a7Vz8fSXkrr0ku8dC+17bB6EZaDSBMpL/i1vXuqE9OhcvXh8WyUJuA1hznMMVZrWGRhejQp+w4269RjalKCUbWq6vyV4l7gi2OYl3sPp0Va75SD6VAj4KDN1+CAAGrceuaqVh3Uv5vEa2+HZTt0RvHfkrBCWQNAaZvtcUHvwslXhrm29jkUVF667WzQWQ8qea0eENsQliKwcL4IiG247HXoDP+qOlP3wm1rOa+P012Ekzqb2ZwJKsN4gc6YKT9fN3M2lp17vnq2CKDKwSjorEvz4i/0B+Zs6fAa2iROzdIzaUNzZnaOGeqMGvVs21/ZthDZnkAzDEjS03YFAuWpc2PpQp35gcnZHpPGe+a7xwidYXeyqIbnDNVCZHYunXkhSVeaiuesQJyh92x73ZO0hzbJbrbDsYO+4nW6mJo92y/AviEkypx8ZbexuaI2b19xsqenU2eSaag09aLBlr7p5HgQearj8pWHWyfJ0jzmeM/lK43SnqY7zdk9oufylWj8oXH8zYNK7bDjN+grcFCyWH8HbdLTXBlqA3wlTqAnWYwRy8/+fB+YK9MpbONC8q/Y5qAwV3Qq+gqHRtMp1DvZtvTY5SvR8V1keUjtkRXZvQ19pVPr2aKCOSunDNtiZZngKxKWSD03ITdzFjXqDE7NajyZswciHqCfMpNk/XQD5grMU5063/2xJxbmi/WGuMccgY0nOdsnk+hc2ZBhTlM+Ccap0d4QWyJoHIKAkvSp0d5g89obCn46TJX2BihNos1vsq/sn2hv2E7cOuO0xjfYOTtrXHuDRJHNEQ+q7LdLMUciCSRP095g89IZRlihjfWGPcBXriUxeZB7PlhvWGvogfmSxpz1lRMspDeYd9ilM68lCUbjDYnqRF9p7Xu+Mumo0BtwrhydOmK+pFHejTegNyQw29BG4WlZX3HQJsnNgux2QF+RX56WLW/SG2b8AKj/3Buyw3uDGn4HMnH+a2qfZHcz8KKl9yXXSnjDumCOFSqr+OklIEfC0Xr2ld1m1B654PKV/N4wD0hvmFhCG+eLA+gNafnKke5FgU68IQHmSL4wdW2MN3xA0CJcyRGdF20HaIptLe9pZow3INy+4kzP+ukB6w02L1+RwneBE3t6zm5faXkvrw5nzqjy+fAVTueIA8gVIXMFnldo7A0QG4EiwqjSxuYKLA4LB1taPkdUOW+YuhRpuOdCjpgRc3YB7InCle/fg0buEXgsNICldI6cw3kD2tLqYIiUz5FzOG+wedECWZDNEbaMcOvsKeRIUoZ7ZH9APM1q3CwiuV2wan3ojJi5kCM6ubYP4Cb5737/55RqW3rpLHwh3ebK4waC+5JwNkdcO/F/v8O4dcZgaYUcmYP1hq/5iqUllyMeMVcyZ7l11oVrNPYGBvCskiNmIFeSTLt0FukrlRzRSe+Ra77AliqeNmhvWGssHE1O+6kr30AuuhdyxBa9Rwb6ChF1ruTIuPQGaS0/Xx733tCpV+gLbxiKvsKtlN126w0FZ8jnjCxLE5ZsjiS58pKeGJsiVXIEeQPpiVRwBj9n957IaZWuOGc3ZXq8M9uW5Yqwc9YonyPJ80V6YthSa0lPS3OFmjM4mamaI+TzdSZ6WjVHbj2xMxP/J0c4T2ywmv8lR4TyxBDZ02o5cumJIFMq5QhdxhwRjhj5C/1xnojWUMqRCNITqVOjp5QjZNvSC7iwN2S5IpwnQkElP730RJZYj/+SIw/picTfm14DAA==);
  background-size: 100% 100%;
  align-items: center;
  display: flex;
  justify-content: center;
  // margin: 0 -.02rem;
  font-size: .4rem;
  // font-weight: 700;
  // border: none;


  color: #fff;
}

.rc_body-content-top-box1>div:nth-child(3) {
  width: 1.12rem;
  height: 1rem;
  background-position: 0 0;
  background-image: url(data:image/webp;base64,UklGRn4CAABXRUJQVlA4THICAAAvecAdEE+gppEU6D5MUWIA/0oosUEgaeP6d/4Jsm2Wm1zkMvdnmIK2bZjwZ9NtLD6jBcCsb1Ik5MoBekZ/uR3A0ba3bYMUkbN8A8U3EGA/j2fkAK6709eeC/jmlghQ+FPWiP47cNs2khxsivHeu0aUN9wWRWaxWX1/41TXtaM6ZCIqlS292prPPc1mY7XvIerdoyuPjalk6eg292hr1FhaT7aLMvVoaTnVrtLeUu+2SvsuD6q4XHOI3WUaVHG5lBD7jUayDuMMsZOrfRq9ci8Skq/sSXn3nV9fFswxNrmt+KaqOtWuk+j4xkF29hvLUOczJF/Jt2XUouy3CltVNczusmdzrN3eZbcVtgbNkXaTbJvD7LI2GNuoBpEvS3eQfFmXkHxZhbVbSL6sC0i+rIdA89U2UHtDyHxtEuHydZeRc6TLFbPztIqz38ifI2fF2alidpYNwouixfGizsbxYrChvBheC8gLUSgvWLC80FBe1OULyIvTKpgXfr6gvDitkLwYtVheuDaUF8xYXiiYF8pIXmg0L6D52vhzJJoXuHzd5ZrZ+SfzQoQZyYvQ2UmVsxO652swL3D5SlhGvmEZ2eWqfP3NvFBm7J6v4D1fGbnnazQvsIxs3XxF88LNF5QXp9WfyYua/Q+454sieaEsUF6w/s97/t/MC2X+rXu+iAiUF6xQXuh/zAvV/3LPd20oL1ihvBCB8oKxvFD+Vbxw8wXkxVBAXuy/8+vLAsWLXaJzHRcgXjQ0qjVDePFARS0jeWGf5QHgxZ6MWgB48WhpGTVHTDWW1pPnSI2SpWPQHNmYypZep86RyQrixaUpMivGPhARAQ==);
  background-size: 100% 100%;
}

.tc_content {
  width: 95%;
  max-width: @maxWidth*0.95;
  // max-width: 12rem;
  //height: 6rem;
  // overflow-x: hidden;
  // overflow-y: auto;
  position: absolute;
  background: @secondary-color;
  padding: 0 0.3rem;
  box-sizing: border-box;
  border-radius: 0.35rem;
  top: -1.3rem;
  // background-image: url("../../assets/images/common/bg1.png");
  position: relative;
  padding-top: 0.2rem;
}

.tc_content2 {
  width: 90%;
  max-width: @maxWidth*0.8;
  // max-width: 12rem;
  background: @third-color;
  border-radius: 0.3rem;
  position: relative;
}

.game_title {
  color: #fff;
  font-size: 0.4rem;
  margin: 0.4rem auto 6px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
  box-sizing: border-box;

  .game_title_left {
    font-size: 0.4rem;
    display: flex;
    align-items: center;
  }

  .more {
    font-size: 12px;
    color: @textcolor3;
  }

  img {
    width: 0.7rem;
    margin-right: 4px;
  }
}

#tc-table {
  border: none;
  margin: auto;
  text-align: center;
  width: 90%;
  background-color: @secondary-color;
  padding: 0.2rem;
  color: #fafafa;

  th {
    height: 0.8rem;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  td {
    width: 50%;
    height: 0.8rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    // border-right: 1px solid rgba(255,255,255,0.2);
  }
}

.tc_head {
  padding: 0.3rem 0 0.4rem 0;
  text-align: center;
  font-weight: 700;
  font-size: larger;
  color: #fff;
}

.tc_bgw {
  padding: 0;
  background-color: @secondary-color;
  color: #fff !important;
  border-width: 0;
}

.paste {
  position: absolute;
  top: .2rem;
  right: .2rem;
  font-size: .26rem;
  color: @textcolor4;
}

.tcbtn {
  background: @anttextcolor;
  color: @primary-color;
  padding: 0.2rem;
  border-radius: 0.1rem;
  float: right;
  margin-top: -0.7rem;
}

.close_notice {
  position: absolute;
  width: 0.7rem;
  height: 0.7rem;
  // top: 0.2rem;
  // right: 0.2rem;
  left: 50%;
  bottom: -1rem;
  margin-left: -0.35rem;
}

.close_recharge_tc {
  position: absolute;
  width: 0.7rem;
  height: 0.7rem;
  // top: 0.2rem;
  // right: 0.2rem;
  left: 50%;
  margin-left: -0.35rem;
  bottom: -1rem;
}

.tc_logo {
  width: 80%;
  display: block;
  margin: 0 auto;
}

.fz3 {
  color: #000;
  font-size: 0.3rem;
  margin-left: 0.1rem;
  font-weight: 700;
}

.jackpot {
  width: 100%;
  margin: 0.2rem auto;
  height: 120px;
  background-image: url("../../assets/images/index/jk1.png");
  background-size: 100% 100%;
  overflow: hidden;
  // background-color: rgba(0,0,0,0.5);
  border-radius: 0.2rem;
}

.jnumber {
  display: flex;
  align-items: center;
  height: 1rem;
  justify-content: center;
  font-size: 0.6rem;
  color: @rechargeColor;
  font-weight: 600;
  margin-top: 60px;
  margin-bottom: 0.2rem;
  // font-family: cursive !important;

  span {
    color: @primary-color !important;
  }
}

.jgame {
  width: 50%;
  display: flex;
  margin: 0 auto;
  justify-content: space-around;
}

.jimg {
  height: 1rem;
  width: 1rem;
}

/deep/ .van-notice-bar__content b {
  color: @anttextcolor !important;
  font-size: .3rem;
}

/deep/ .van-notice-bar__content span {
  color: @anttextcolor !important;
  font-size: .3rem !important;
}

.mytest_svg {
  width: 0.8rem;
  height: 0.66rem;
}

.ppl {
  display: block;
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  font-size: 0.3rem;
  color: @textcolor2;
}

.nav_img {
  display: block;
  // height: 1rem;
  margin: 0 auto;
  font-size: 0.8rem;
  height: 20px;
  // width: 0.8rem;
}

.nav_title {
  // height: 2rem;
  // display: flex;
  // border-bottom: 1px solid #e5e5e5;
  text-align: center;
}

.van-dialog {
  // background: #FFF;
  border: 1px solid #e14ce1;
}

.checkBox {
  padding: 10px;
  display: flex;
  justify-content: center;

  .check {
    padding: 6px 10px;
    background-color: rgba(0, 0, 0, 0.2);

    :deep(.van-checkbox__label) {
      color: #fff;
    }

    :deep(.van-icon-success) {
      background-color: transparent !important;
    }

    :deep(.van-checkbox__icon--checked) {
      background-color: #04BE02 !important;
    }
  }
}

.codeInput {
  font-size: 11px;
  border-radius: 7px;
  height: 30px;
  line-height: 30px;
  background-color: transparent !important;
  padding-right: 41px !important;
  border-color: @textcolor1 !important;
  box-shadow: none !important;
  border: 0.01rem solid;
  padding-left: .3rem !important;
}

/deep/ .van-field__label {
  width: auto;
  // margin-left: .3rem;
}

/deep/ .van-tabs__wrap--scrollable {
  /* 自定义样式 */
  color: @anttextcolor;
  background: transparent;
  border-width: 1.5rem;
  display: flex;
  border-bottom: 1px solid @bodercolor;
}

/deep/ .van-cell::after {
  content: none;
}

/deep/ .van-tabs__wrap--scrollable .van-tab {
  color: @textcolorf;
}

/deep/ .van-tabs__wrap--scrollable .van-tab--active {
  color: @anttextcolor;

  .ppl {
    color: @textcolor1;
  }
}

/deep/ .van-field__control {
  color: #fff;
}

/deep/ .van-button--default {
  // background: #ffdc83 !important;;
  color: #ffdc83;
  background: #a541ff !important;
  // background: linear-gradient(90deg, #3FBBFE 0%, #A541FF 100%);
}

.category-item .slot_name {
  width: 100%;
  text-align: center;
  height: 0.7rem !important;
  line-height: 0.7rem !important;
  font-weight: 700;
  font-size: 0.35rem;
  color: #e14ce1;
}

.category-item .s_active {
  color: #fff;
}

.sec-title {
  color: #fff;
  font-size: 0.35rem;
  line-height: 0.6rem;
  //margin-left: 0.25rem;
}

.svg_box {
  width: 0.8rem;
  height: 0.66rem;
}

.c-sm-des {
  width: 95%;
  margin: 0.2rem auto 0 auto;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  height: 1rem;

  img {
    width: 1.6rem;
  }

  span {
    display: block;
    font-size: 0.46rem;
    color: #fff;
    font-weight: bold;
  }
}

.sec-img {
  width: 0.4rem;
}

.ci-des {
  display: block;
  color: #e14ce1;
  font-size: 0.26rem;
}

.cdactive {
  color: #ffdc83 !important;
}

.ci-img {
  display: block;
  width: 40px;
  height: 40px;
}

.category-item {
  width: 18%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0.1rem 0;
  margin: 0 auto;
  border-radius: 0.2rem;
  border: 1px solid #895db3;
  background-image: linear-gradient(180deg,
      rgba(146, 30, 146, 1) 0,
      rgba(146, 30, 146, 1) 0,
      rgba(85, 9, 85, 1) 100%,
      rgba(85, 9, 85, 1) 100%);
}

.cot {
  text-align: center;
  color: gold;
  margin-top: -10px;
}

.baoxiang {
  width: 55px;
  display: block;
  margin: 0 auto;
  //margin-top: -10px;
}

.daily-gift2 {
  position: absolute;
  width: 65px;
  height: 75px;
  bottom: 195px;
  right: 10px;
  z-index: 2;
  background-color: #0d7319c7;
  border-radius: 15px;
  text-align: center;
}

.daily-gift {
  position: absolute;
  width: 65px;
  bottom: 55px;
  left: 10px;
  z-index: 2;
  animation: my-btn 2s ease-in infinite;
  background-color: #0d73196a;
  border-radius: 50%;
}

.top-right-div {
  padding: 0 5px;

  height: 50px;
  //width: 120px;
  //flex-wrap: wrap;
}

.goReachrge {
  display: block;
  // height: 40px;
  display: flex;
  align-items: center;
  padding: 5px 8px;
  //background-image: linear-gradient(to right, #a60092, #6011d0) !important;
  color: white;
  border-radius: 15px;
  font-size: 0.4rem;
  background: #224131;
}

.head_image {
  height: 30px;
  margin-left: 10px;
  border-radius: 50%;
  border: 1px solid #fff;
}

.recharge-wrap {
  height: 25px;
  margin-left: 10px;
  border-radius: 0.24rem;
  box-shadow: 0 0 0 0 #dd234b;
  // width: 0.8rem;
  // height: 0.56rem;
  animation: WalletButtonBlink-JUR1h 2.5s ease 0s infinite normal none running;
}

.recharge-img {
  // width: 30px;
  height: 100%;
  // margin-left: 10px;
}

@keyframes WalletButtonBlink-JUR1h {

  10%,
  90% {
    transform: translate3d(-2px, 0, 0);
  }

  0% {
    transform: scale(1);
  }

  70% {
    box-shadow: 0 0 0 0.2rem rgba(255, 49, 65, 0);
    transform: scale(1);
  }

  to {
    box-shadow: 0 0 rgba(255, 49, 65, 0);
    transform: scale(1);
  }
}

#myiframe {
  height: 100%;
  width: 100%;
  background: #3e4b58;
  position: absolute;
}

.game-box {
  position: fixed;
  width: 100%;
  // max-width: @maxWidth;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
  left: 0;
  right: 0;

  /deep/ iframe {
    width: 100vw;
  }
}

.back_to_desk {
  position: absolute;
  top: 0;
  left: 0;
  //background: rgba(0, 0, 0, 0.5);
  z-index: 999999;
  height: 1rem;
  width: 1rem;
  // display: flex;
  border-radius: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 0.02rem solid #fff;
  color: #fff;
  font-size: 0.22rem;
  text-align: center;
  padding: 0.2rem 0.2rem;
}

.close_game_btn {
  font-size: 0.8rem;
  border-radius: 50%;
  color: #fff;
}

.game_name {
  width: 100%;
  text-align: center;
  position: absolute;
  height: 0.8rem;
  line-height: 0.8rem;
  bottom: 0.3rem;
  color: #fff;
  font-size: 0.45rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
  //background-color: rgba(0, 0, 0,0.5);
}

.gameimg-wrap {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
}

.game-img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 0.2rem;
}

.game-name {
  font-size: 0.3rem;
  color: #c7c7c7;
  text-align: center;
}

.game-name_logo {
  background-image: linear-gradient(90deg,
      rgba(138, 53, 128, 1) 0,
      rgba(138, 53, 128, 1) 0,
      rgba(111, 7, 184, 1) 100%,
      rgba(111, 7, 184, 1) 100%);
  border-radius: 50%;
  height: 0.7rem;
  width: 0.7rem;
  border: 1px solid #ac69a8;
  position: absolute;
  top: 74%;
  z-index: 8;
  margin-top: 11px;
}

.game-name_logo img {
  margin: 5px 5%;
  width: 90%;
}

.game-name_text {
  background-image: linear-gradient(90deg,
      rgba(138, 53, 128, 1) 0,
      rgba(138, 53, 128, 1) 0,
      rgba(111, 7, 184, 1) 100%,
      rgba(111, 7, 184, 1) 100%);
  border-radius: 12px;
  height: 0.6rem;
  line-height: 0.6rem;
  border: 1px solid #ac69a8;
  width: 90%;
  position: relative;
  margin-left: 10%;
  margin-top: 5px;
  padding-left: 0.5rem;
}

.search-wrap {
  //background: rgba(250, 223, 0,0.8);
  border: 1px solid #f8b600;
  height: 0.8rem;
  width: 95%;
  margin: 0.3rem auto 0 auto;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.simg {
  font-size: 0.6rem;
  margin-right: 0.2rem;
  color: @popupcolor;
}

.input-keyword {
  width: 70%;
  height: 100%;
  color: #fff;
  font-size: 0.32rem;
  float: left;
  text-indent: 10px;
  background: none;
  border: none;

  input {
    background: none;
    border: none;
    outline: none;
  }
}

/deep/ input.van-field__control::placeholder {
  color: @textcolor1;
  font-size: .24rem;
}

.input-keyword::placeholder {
  color: #f8b600;
}

.game-list {
  width: 95%;
  margin: 0.2rem auto 0rem auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-start;
}

.game-item {
  width: 25%;
  //height: 3.5rem;
  margin-bottom: 0.3rem;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
}

.nowork {
  width: 100%;
  position: relative;
  z-index: 1;
  background: rgba(0, 0, 0, 0.34);
  margin: 0 auto;
  border-radius: 0.25rem;
}

.innerbox {
  width: 95%;
  padding-bottom: 95%;
  height: 0;
  position: relative;
  background-size: 100% 100%;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 0.25rem;
  box-sizing: border-box;
  // border: 1px solid #feb705;
  margin: 0 auto 30px;

  .like_icon {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 1;
  }

  // .bgImg {
  //   width: 2.8rem;
  //   height: 3.7rem;
  // }
  .good {
    width: 0.6rem;
  }
}

.new-list {
  position: relative;
  margin-bottom: 0.3rem;
}

.xbanner {
  width: 100%;
  box-sizing: border-box;

  img {
    width: 100%;
    border-radius: 0.2rem;
    border: 0.06rem solid #ba955b;
    box-sizing: border-box;
  }
}

.show_more {
  color: @anttextcolor;
  width: 95%;
  margin: 0 auto;
  border-radius: 0.2rem;
  text-align: center;
  font-size: 11px;

  div {
    height: 0.5rem;
    line-height: 0.5rem;
    color: @textcolor3;
  }
}

.item-btn-left {
  float: left;
  padding: 8px 0;
  font-size: 0.35rem;
  //color: #AA976F;
  color: #a7a3a3;
}

.des-right-top {
  height: 20px;
  line-height: 20px;
  margin: 0 !important;
  font-size: 0.4rem;
  //font-weight: 700;
  color: #ffffff;
}

.des-right-mid {
  height: 20px;
  line-height: 20px;
  margin: 0 !important;
  font-size: 0.4rem;
  //font-weight: 700;
  //color: #826B47;
  color: #ffffff;
}

.des-right-btm {
  height: 20px;
  line-height: 20px;
  margin: 0 !important;
  font-size: 0.4rem;
  //font-weight: 700;
  //color: #826B47;
  color: #ffffff;
}

.des-left-btm {
  font-size: 0.4rem;
  color: #ad9d89;
}

.des-left-top {
  height: 30px;
  line-height: 30px;
  color: #e64d20;
  font-size: 0.7rem;
  font-weight: 700;
}

.game_item_name {
  //width: 2rem;
  margin-top: 0.1rem;
  color: #fff;
  font-size: 0.3rem;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
}

.game_item_pg_name {
  color: #fff;
  text-align: center;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  //margin: 0 auto;
  width: 100%;
  font-size: 10px;
  font-weight: 500;
  left: 0;
  bottom: -24px;
  height: 0.7rem;
  // line-height: 0.5rem;
}

.des-left {
  width: 36%;
  height: 100%;
  //background: #07c160;
  text-align: center;
  float: left;
}

.des-right {
  width: 64%;
  height: 100%;
  //background: #07c160;
  //text-align: left;
  text-indent: 0.5rem;
  float: left;
}

.item_div4 {
  position: relative;
}

.progress-number {
  position: absolute;
  color: #947f59;
  left: 72%;
  height: 10px;
  top: -1px;
  margin: 0 !important;
  font-size: 12px;
  font-weight: 700;
}

.item-des {
  height: 60px;
  //background: #8d8d8f;
  width: 100%;
  margin: 0 !important;
}

/deep/ .van-cell {
  padding: 15px 26px;
}



.progress-div {
  width: 70%;
  height: 10px;
  border-radius: 5px;
  background: #e2dcd4;
  position: relative;
}

.progress-in {
  height: 10px;
  border-radius: 5px;
  position: absolute;
  left: 0;
  top: 0;
  background: #3ba00e;
  width: 50%;
  margin: 0 !important;
}

.home_wrap {
  // position: relative;
  width: 100%;
  min-height: 100vh;
  position: relative;
  padding-top: @headerHeight;
  background-image: url("../../assets/images/common/bg.png");
  background-color: @secondary-color;
  // background-size: 2rem;
}

.top-right-menu {
  position: fixed;
  left: 0;
}

.search_box {
  width: 90%;
  height: 32px;
  background-color: #f6f6f6;
  border-radius: 17px;
  border: solid 1px #1989fa;
  margin: 8px auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px 0 14px;

  .search_inp {
    flex: 1;
    margin: 0 8px;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    height: 20px;
  }
}

/deep/ .el-carousel__mask {
  background: transparent !important;
}

.swiper-container {
  width: 95%;
  border-radius: 0.3rem;
  margin: 0 auto 0 auto;
  overflow: hidden;
  padding-top: 0.2rem;

  .van-swipe-item {
    overflow: hidden;
    // width: 10rem !important;
  }

  a {
    float: left;
    width: 100%;
    height: 100%;
  }

  img {
    border-radius: 0;
    // margin-left: 2%;
    height: 100%;
    width: 100%;
  }
}

.work_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  border-radius: 0.2rem;
  width: 98%;
  margin: 0.1rem auto 0.3rem auto;
}

.notice_root {
  width: 95%;
  height: 0.8rem;
  overflow: hidden;
  position: relative;
  display: flex;
  margin: 0 auto;
  align-items: center;
  border-radius: 0.2rem;
  margin-top: 0.1rem;

  .mailIcon {
    width: 20px;
    height: 20px;
    margin-left: 4px;
  }

  .container {
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    display: flex;
    align-items: center;
    height: 100%;
  }
}

.notice_content {
  width: 100%;
  height: 100%;
  padding: 0;
  font-size: 0.32rem;
}

@keyframes scroll-left {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}

.notice_root .notice_icon {
  overflow: hidden;
  position: relative;
  display: flex;
  // width: 0.5rem;
  height: 0.43rem;
  margin-left: 0;
  margin-right: 2px;
}

/deep/ .van-tab {
  width: 25%;
  line-height: 0;
}

/deep/ .van-tabs--line .van-tabs__wrap {
  width: 100%;
  height: auto;

  &>div {
    width: 100%;
  }
}

.nav_box {
  // width: 95%;
  background-color: @primary-color;
  background-size: cover;
  // margin: 0 auto 0.2rem auto;
  padding-top: 6px;

  svg {
    color: @textcolor2 !important;
  }
}

/deep/ .van-tabs__nav--line {
  padding-bottom: 0 !important;
}

/deep/ .van-tabs__line {
  bottom: 0 !important;
}

/deep/ .van-button--disabled {
  background-color: #999999;
  opacity: 10;
}

.submitCode {
  width: 95%;
  border-radius: .2rem;
  height: 1rem;
  font-size: .32rem;
}

/deep/ .van-button--primary {
  border: none;
}

/deep/ .van-button__text {
  background: none !important;
  color: #fff;
}

.adv {
  width: 96%;
  margin: 0.2rem auto 0 auto;
}

.adv img {
  width: 100%;
}

.service {
  position: fixed;
  width: 1rem;
  bottom: 2rem;
  right: 0.1rem;
  z-index: 2;
  background: white;
  border-radius: 50%;
}

#indexbr_box {
  position: fixed;
  width: 78px;
  bottom: 2rem;
  right: 10px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  img {
    margin-bottom: 5px;
  }
}

.telegram {
  position: relative;
  display: inline-block;
  width: 78px;
  padding-left: 6px;
  opacity: 1;

  // animation-name: scaleAnimation; // 动画名
  // animation-duration: 3s; // 动画时长
  // animation-iteration-count: infinite; // 永久动画
  // transition-timing-function: ease-in-out; // 动画过渡
  img {
    width: 100%;
    height: 100%;
  }

  .icon_box {
    position: absolute;
    right: -5px;
    top: -5px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .close_icon {
      color: @textcolor1;
      font-size: 14px;
    }
  }
}

.invitation {
  width: 1.6rem;
  z-index: 1;
  // animation-name: scaleAnimation; // 动画名
  // animation-duration: 3s; // 动画时长
  // animation-iteration-count: infinite; // 永久动画
  // transition-timing-function: ease-in-out; // 动画过渡
  //box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); // 元素阴影
}

@keyframes scaleAnimation {

  // 动画设置
  0% {
    transform: scale(0.2);
  }

  25% {
    transform: scale(0.5);
  }

  50% {
    transform: scale(0.8);
  }

  75% {
    transform: scale(1.08);
    transform: rotate(360deg);
  }
}

.download {
  position: fixed;
  width: 1.2rem;
  bottom: 1.6rem;
  right: 0.1rem;
  z-index: 1;
  border-radius: 50%;
  opacity: 1;

  img {
    width: 100%;
    height: 100%;
  }
}

.van-button__text {
  background: white;
}

.hoverButton {
  margin-top: 10px;
  background-color: @primary-color;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  z-index: 10;
  width: 60px;
  min-height: 54px;
  border: 2px solid @bodercolor2;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 9px;
  margin-left: 16px;
  transform: translateX(4px);

  span {
    color: @textcolor1;
  }

  img {
    width: 19px;
    height: 20px;
  }
}

.sign-box {
  width: 100%;
  text-align: center;
}

.openPage {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: @primary-color;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11111;

  .skip-button {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    padding: 0.3rem 0.6rem;
    border-radius: 1rem;
    font-size: 0.35rem;
    cursor: pointer;
    z-index: 11112;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.3);

    &:hover {
      background: rgba(0, 0, 0, 0.8);
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.95);
    }
  }

  img {
    width: 100%;
    max-width: @maxWidth;
    height: 100vh;
    // animation: logo 1s infinite;
  }
}

@keyframes logo {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}
</style>
